// extracted by mini-css-extract-plugin
export default {"root":"MultiLangInput_root__i3xXo","shortLang":"MultiLangInput_shortLang__BECwc"};